import React, { FC } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { MapPage } from './pages/map';
import { SpotDetails } from './pages/map/spot/[id]';
import { RegisterPage } from './pages/register';
import { EditSpot } from './pages/map/spot/tabs/Details/edit';
import { ListPage } from './pages/list';
import { SpotListPage } from './pages/list/[id]';
import { HelpPage } from './pages/help';
import { GeolocationHelpPage } from './pages/help/geolocation';
import { StampCardPage } from './pages/stampcard';
import { StampCardEditPage } from 'pages/stampcard/edit';
import { SpotAdminPage } from './pages/map/admin/spotadmin';
import { SpotQrPage } from './pages/map/admin/spotqr';
import { SpotUserListPage } from './pages/map/admin/spotuserlist';
import { QrCode } from './pages/qrcode';
import { SpotStaffPage } from './pages/map/admin/spotstaff';
import { MyListPage } from './pages/mylist';


export const App: FC = () => {
    return (
        <Router>
            <Route exact path="/map" component={MapPage}></Route>
            <Route exact path="/map/qr" component={QrCode}></Route>
            <Route exact path="/map/spot/:id" component={SpotDetails}></Route>
            <Route exact path="/map/register" component={RegisterPage}></Route>
            <Route exact path="/map/spot/:id/edit" component={EditSpot}></Route>
            <Route exact path="/map/spot/:id/admin" component={SpotAdminPage}></Route>
            <Route exact path="/map/spot/:id/users" component={SpotUserListPage}></Route>
            <Route exact path="/map/spot/:id/staff" component={SpotStaffPage}></Route>
            <Route exact path="/map/spot/:id/qr" component={SpotQrPage}></Route>
            <Route exact path="/map/stampcard" component={StampCardPage}></Route>
            <Route exact path="/map/stamps/edit" component={StampCardEditPage}></Route>
            <Route exact path="/map/stamps/:id/edit" component={StampCardEditPage}></Route>
            <Route exact path="/map/stampcard/:id" component={StampCardPage}></Route>
            <Route exact path="/map/list" component={ListPage}></Route>
            <Route exact path="/map/list/:genre" component={SpotListPage}></Route>
            <Route exact path="/map/help" component={HelpPage}></Route>
            <Route exact path="/map/help/geolocation" component={GeolocationHelpPage}></Route>
            <Route exact path="/map/my_list" component={MyListPage}></Route>
            <Route exact path="/" component={() => {
                const isAppAccess = window.navigator.userAgent === 'Salon.jp App/iOS';
                if (isAppAccess) {
                    window.location.href = window.location.origin + '/dashboard';
                    return null;
                };
                window.location.href = window.location.origin;
                return null;
            }}></Route>

            <style jsx global>{`
                html {
                    font-family: sans-serif;
                    -ms-text-size-adjust: 100%;
                    -webkit-text-size-adjust: 100%;
                }
                html,
                body {
                    height: 100%;
                    margin: 0;
                    box-sizing: border-box;
                    background: url("/img/bg_tri.png");
                    font-family: 'Roboto', 'Noto Sans JP';
                }
                * {
                    box-sizing: border-box;
                    white-space: pre-line;
                }
            `}</style>
        </Router>
    );
};
